/**
 * Wave 6 — EPC Contract handoff + master cockpit mount point.
 */
import React from 'react';
import { EpcContractCockpit } from './EpcContractCockpit';

export type EpcContractHandoffPanelProps = {
  contract: Record<string, unknown>;
  onUpdated?: () => void;
};

/** @deprecated Prefer EpcContractCockpit — kept as stable import for register drawer. */
export const EpcContractHandoffPanel: React.FC<EpcContractHandoffPanelProps> = ({
  contract,
  onUpdated,
}) => <EpcContractCockpit contract={contract} onUpdated={onUpdated} />;

export default EpcContractHandoffPanel;
